// extracted by mini-css-extract-plugin
export default {"modalContent":"wX-z"};